import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/style.css";

function HomePage() {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const terminalEndRef = useRef(null);

  // Auto-typing sequence on mount
  useEffect(() => {
    const initialSequence = [
      { text: "$ node danilo_turasov.js", delay: 200 },
      { text: "Initializing profile setup...", delay: 600 },
      { text: "Loading modules: [React, JavaScript, CSS3, Python, Node] - SUCCESS", delay: 1000 },
      { text: "Status: " + t("home.status"), delay: 1400 },
      { text: "$ danilo.getCoreStack()", delay: 1800 },
      { text: '=> ["React.js", "JavaScript", "Python", "Node.js", "SQL"]', delay: 2200 }
    ];

    initialSequence.forEach((line) => {
      setTimeout(() => {
        setLogs((prev) => [...prev, line.text]);
      }, line.delay);
    });
  }, [t]);

  // Scroll to bottom of terminal when logs update internally without scrolling the page
  useEffect(() => {
    const terminalBody = document.querySelector(".terminal-body");
    if (terminalBody) {
      terminalBody.scrollTo({ top: terminalBody.scrollHeight, behavior: "smooth" });
    }
  }, [logs]);

  const handleLinkClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleConsoleCommand = (cmd) => {
    let response = "";
    let prompt = `$ danilo.${cmd}()`;

    switch (cmd) {
      case "getSkills":
        response = '=> ["React.js", "Vue.js", "Nuxt.js", "Node.js", "Python", "SQL", "C#", "Wix Velo", "HTML5", "CSS3", "Git"]';
        break;
      case "getEducation":
        response = '=> ["IT Step Computer Academy (Software Developer)", "Academy of Future Professions (Python Developer)"]';
        break;
      case "getExperience":
        response = '=> ["Davydov Consulting (Web Developer - Wix Velo, Jul 2025 - Oct 2025)"]';
        break;
      case "clear":
        setLogs([]);
        return;
      default:
        response = "=> Unknown Command";
    }

    setLogs((prev) => [...prev, prompt, response]);
  };

  return (
    <section id="home" className="section hero-container-layout">
      <div className="hero-grid">
        
        {/* Left Column: Greeting, details and buttons */}
        <div className="hero-content-column reveal">
          <div className="status-badge" style={{ display: "inline-flex" }}>
            <span className="status-dot"></span>
            <span>{t("home.status")}</span>
          </div>
          
          <h2 className="hero-title">
            <span className="gradient-text">{t("home.heading")}</span>
          </h2>
          
          <p className="hero-subtitle">
            {t("home.text")}
          </p>
          
          <div className="hero-actions reveal-delay-2">
            <a href="#projects" onClick={(e) => handleLinkClick(e, "projects")} className="btn btn-primary">
              {t("home.btn_projects")}
            </a>
            <a href="#contacts" onClick={(e) => handleLinkClick(e, "contacts")} className="btn btn-secondary">
              {t("home.btn_contacts")}
            </a>
          </div>
        </div>

        {/* Right Column: Interactive Developer Terminal */}
        <div className="hero-terminal-column reveal reveal-delay-1">
          <div className="terminal-window">
            <div className="terminal-header">
              <div className="terminal-dots">
                <span className="terminal-dot dot-red"></span>
                <span className="terminal-dot dot-yellow"></span>
                <span className="terminal-dot dot-green"></span>
              </div>
              <span className="terminal-title">bash - danilo_turasov.js</span>
            </div>
            
            <div className="terminal-body">
              {logs.map((log, index) => (
                <div key={index} className="terminal-line">
                  {log.startsWith("$") ? (
                    <span className="terminal-prompt-color">{log}</span>
                  ) : log.startsWith("=>") ? (
                    <span className="terminal-output-color">{log}</span>
                  ) : (
                    <span>{log}</span>
                  )}
                </div>
              ))}
              <div ref={terminalEndRef} />
            </div>

            <div className="terminal-controls">
              <span className="terminal-cmd-label">Run command:</span>
              <div className="terminal-buttons">
                <button className="terminal-btn" onClick={() => handleConsoleCommand("getSkills")}>
                  .getSkills()
                </button>
                <button className="terminal-btn" onClick={() => handleConsoleCommand("getEducation")}>
                  .getEducation()
                </button>
                <button className="terminal-btn" onClick={() => handleConsoleCommand("getExperience")}>
                  .getExperience()
                </button>
                <button className="terminal-btn clear-btn" onClick={() => handleConsoleCommand("clear")}>
                  clear
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default HomePage;
